import { makeApi } from "@zodios/core";
import { z } from "zod";

import { languageSchema } from "@skilitics/nautilus-core-designer-data/schemas";

export const languagesApi = makeApi([
  {
    method: "get",
    path: "/languages",
    alias: "getLanguages",
    response: z.array(languageSchema),
  },
  {
    method: "post",
    path: "/languages",
    alias: "createLanguage",
    parameters: [
      {
        type: "Body",
        name: "Language",
        schema: languageSchema,
      },
    ],
    response: languageSchema,
    status: 201,
  },
]);

export type Language = z.infer<typeof languageSchema>;
